






















import { TypeComponentNoti } from "@/enums/enums";
import { Component, Vue, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

const StoreAlert = namespace("Alert");

@Component
export default class ModalAlertMessage extends Vue {
  private showModalAlert = false;
  private img: any = "";
  private message: any = "";

  @StoreAlert.Getter
  private getAlertMessage!: any;
  @StoreAlert.Action
  private ClearAlertMessage!: () => void;

  @Watch("getAlertMessage", { deep: true })
  getAlertMessageChanged(newVal: any) {
    if (this.getAlertMessage.type == TypeComponentNoti.Success) {
      this.showModalAlert = true;
      this.img = require("@/assets/img/alertMessage/success.png");
      this.message = this.getAlertMessage.message;
    } else if (this.getAlertMessage.type == TypeComponentNoti.Error) {
      this.showModalAlert = true;
      this.img = require("@/assets/img/alertMessage/fail.png");
      this.message = this.getAlertMessage.message;
    }
  }

  public DoClearAlertMessage() {
    this.showModalAlert = false;
    this.message = "";
    this.ClearAlertMessage();
  }
}
